import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import './main.less';
import { selectors as rootSelectors } from '../../root';
import { actions, selectors } from './';

import renderViewState from '../../shared/render-views-state';
import Filters from '../../shared/filters/main';
import Search from '../../shared/search/main';
import Calendar from '../../shared/calendar/main';
import Table from '../components/table/main';
import SwitchControlMulti from '../../shared/switch-control/multi/main';

import PageContainer from '../../shared/page-container/main';
import tabs from '../tabs';

const Main = renderViewState((props) => (
	<PageContainer name='Goods' tabs={tabs}>
		<div className='container__content goods-list'>
			<div className='programs-list__filter-position clearfix'>
				<Filters {...props} {...props.filters} />
			</div>

			<div className='ui-control-bar'>

				<div className="ui-control-bar__item modify-item---search">
					<div className="ui-control-bar__item-position">
						<Search
							{...props}
							form="goodsSearchForm"
							action={props.search}
							autoFocus={true} />
					</div>
				</div>

				<div className='ui-control-bar__item'>
					<div className='ui-control-bar__item-position'>
						<SwitchControlMulti
							intl={props.intl}
							filters={props.switchControlMultiStatusItems}
							choose={filterValue => {
								props.switchControlMultiChooseFilter(filterValue);
								props.apply();
							}}
						/>
					</div>
				</div>

				<div className='ui-control-bar__item modify-item---calendar'>
					<div className='ui-control-bar__item-position'>
						<Calendar
							{...props.calendar}
							onInit={props.calendarInit}
							onToggle={props.calendarToggle}
							onChange={props.calendarChange}
							onApply={props.calendarApply}
							intl={props.intl}
						/>
					</div>
				</div>

				<div className='ui-control-bar__item'>
					<div className='ui-control-bar__item-position'>
						{props.can('create') && (
							<Link
								to='/goods/edit/'
								className='ui-btn ui-btn-primary ui-btn-sign__plus'
							>{props.intl('Add good')}</Link>
						)}
						<button
							className='ui-btn ui-btn-primary'
							onClick={props.apply}
						>{props.intl('Apply')}</button>
						<button
							className='ui-btn ui-btn-secondary ui-icon-clear'
							onClick={props.clear}
						/>
					</div>
				</div>

			</div>
			<Table
				{...props}
				isIndexing
				narrow
			/>
		</div>
	</PageContainer>
), 'view');

export default connect(
	state => ({
		data: selectors.getData(state),
		table: selectors.getTable(state),
		filters: selectors.getFilters(state),
		searchData: selectors.getSearchData(state),
		pagination: selectors.getPagination(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		progressBar: selectors.getProgressBar(state),
		error:selectors.getError(state),
		calendar: selectors.getCalendar(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		switchControlMultiStatusItems: selectors.getSwitchControlMultiStatusItems(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/goods/list/main.js